import React from 'react';
import PropTypes from 'prop-types';

const Main = ({ children, style={} }) => {
  return (
    <div className="flex-main" name="Main" style={style}>{children}</div>
  );
};

Main.propTypes = {
  children: PropTypes.any,
  style: PropTypes.object
};

export default Main;
